import ModalWindow from "../../../ModalWindow/ModalWindow";

const RemoveListModal = ({id, remove, hide, removeTitle, removeText}) => {

    if(!removeText)
        removeText = "Czy na pewne chcesz kontynuować?";

    return (
        <ModalWindow 
            title={removeTitle}
            minWidth={"30%"}
            content={
                <div>
                    {removeText}
                </div>
            }
            buttons={[
                { Text: "Usuń", onClick: () => remove(id) }, 
                { Text: "Anuluj", className: "modalSecondaryBtn", onClick: () => hide()}
            ]}
        />
    )
}

export default RemoveListModal;